module.exports = __webpack_public_path__ + "static/media/ads (3).c653e972.png";